import { render, staticRenderFns } from "./EvCategoryBlock.vue?vue&type=template&id=704d82cf&scoped=true&"
import script from "./EvCategoryBlock.vue?vue&type=script&lang=js&"
export * from "./EvCategoryBlock.vue?vue&type=script&lang=js&"
import style0 from "./EvCategoryBlock.vue?vue&type=style&index=0&id=704d82cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704d82cf",
  null
  
)

export default component.exports